export const getHeaderHeight = (): { height: number; scrolledHeight: number } => {
    const height = parseInt(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    const scrolledHeight = parseInt(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-height-scrolled')
    );

    return { height: height, scrolledHeight: scrolledHeight };
};
